import { render, staticRenderFns } from "./AgendaView.vue?vue&type=template&id=67de264a&"
import script from "./AgendaView.vue?vue&type=script&lang=js&"
export * from "./AgendaView.vue?vue&type=script&lang=js&"
import style0 from "./AgendaView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports